import { EventOrderStem, RecipeModel, RecipeStem, Stem } from 'src/common/common.interface'
import { postHttp, deleteHttp, putHttp } from './apiLayer'

export interface AddRecipeStemPayload {
  stemId?: number
  quantity: number
  supplierStemId?: number
}

export interface UpdateRecipeStemPayload {
  stemId?: number
  quantity?: number
  supplierStemId?: number
  stemRole?: string
  roleIndex?: number
}

export interface AddRecipeStemPayloadResponse {
  id: number
}

export interface ChangeStemPayload {
  newStemId: number
}

export interface IApplyStemToProductPayload {
  stemId: number
  quantity?: number
  stemRole?: string
  roleIndex?: number
  sequenceNum?: number
  stem?: Stem
}

export interface ApplyEventStemsToAllProductsPayload {
  recipeIds: number[]
  stemsPayload: IApplyStemToProductPayload[]
  type?: 'event-stem' | 'formula-stem'
}

export interface ApplyFormulaStemsToProductsPayload {
  recipeId: number
  stemsPayload: IApplyStemToProductPayload[]
}

export interface EventStemPayload {
  id?: number
  stemId: number
  sequenceNum?: number
  stemRole?: string | null
  roleIndex?: number | null
  isDeleted?: boolean
}
interface RecipePayload {
  productId: number
  recipeId: number
}
export interface ApplyFStemsOrEStemsToProductsPayload {
  eventOrderId: number
  recipePayloads: RecipePayload[]
  eventStemPayloads: EventStemPayload[]
}

export interface ReplaceRecipeStemByNewStemPayload {
  oldStemId: number
  newStemId: number
  recipeIds?: number[]
}

interface ImportRecipeHardGoodPayload {
  hardGoodId: number
  quantity: number
}

interface ImportRecipe {
  recipeId: number
  stemsPayload: IApplyStemToProductPayload[]
  hardGoodsPayload?: ImportRecipeHardGoodPayload[]
  defaultPrepTimeMinutes?: number | null
  defaultDesignTimeMinutes?: number | null
  defaultInstallTimeMinutes?: number | null
  defaultLoadingTimeMinutes?: number | null
  defaultInstructions?: string | null
}
export interface ImportRecipesPayload {
  eventOrderId: number
  collectionId: number
  importPayload: ImportRecipe[]
}

export const addRecipeStem = async (
  recipeId: number,
  payload: AddRecipeStemPayload
): Promise<AddRecipeStemPayloadResponse> => {
  const result = await postHttp(`/recipes/${recipeId}/stems`, payload)
  return result.data
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteRecipeStem = async (recipeId: number, recipeStemId: number): Promise<any> => {
  const result = await deleteHttp(`/recipes/${recipeId}/stems/${recipeStemId}`)
  return result.data
}

export const updateRecipeStem = async (
  recipeId: number,
  recipeStemId: number,
  payload: UpdateRecipeStemPayload
): Promise<AddRecipeStemPayloadResponse> => {
  const result = await putHttp(`/recipes/${recipeId}/stems/${recipeStemId}`, payload)
  return result.data
}

export const changeStem = async (
  recipeId: number,
  stemId: number,
  payload: ChangeStemPayload
): Promise<AddRecipeStemPayloadResponse> => {
  const result = await putHttp(`/recipes/${recipeId}/stem/${stemId}`, payload)
  return result.data
}

export const applyEventStemsToAllProductsAPI = async (
  payload: ApplyEventStemsToAllProductsPayload
): Promise<RecipeStem[]> => {
  const result = await postHttp(`recipes/apply-event-stems-to-all-products`, payload)
  return result.data
}

export const replaceRecipeStemByNewStemAPI = async (
  eventOrderId: number,
  payload: ReplaceRecipeStemByNewStemPayload
): Promise<RecipeStem> => {
  const result = await putHttp(`/eventOrders/${eventOrderId}/replaceRecipeStemByNewStem`, payload)
  return result.data
}

export const applyFormulaStemsToProductsAPI = async (
  payload: ApplyFormulaStemsToProductsPayload[]
): Promise<RecipeStem[]> => {
  const result = await postHttp(`recipes/apply-formula-stems-to-products`, payload)
  return result.data
}

export const saveEventStemsAndApplyStemsToProducts = async (
  payload: ApplyFStemsOrEStemsToProductsPayload
): Promise<{
  eventStems: EventOrderStem[]
  recipeStems: RecipeStem[]
}> => {
  const result = await postHttp(`recipes/save-and-apply-stems-to-products`, payload)
  return result.data
}

export const importRecipesAPI = async (payload: ImportRecipesPayload): Promise<RecipeModel[]> => {
  const result = await postHttp(`recipes/import-recipes`, payload)
  return result.data
}
